export class LoadUserContext {
    static readonly type = '[User Context] Load user context';
}
